module.exports = __webpack_public_path__ + "resources/images/sns-76a6c4acfba40178bfa4e79652bd382c-cache.png";